import React from 'react';
import { HStack, Box, Button, VStack, Separator, Heading, Spacer } from '@chakra-ui/react';
import theme from '../theme';
import PhotoAttachments from '../components/PhotoAttachments';

export default ({ attachmentsList, readOnly, close }) => {
	const [add, setAdd] = React.useState(false);

	return (
		<Box p="16px">
			<HStack spacing={2} justify="flex-end" p={2}>
				<VStack spacing="8px" mb="24px" align="flex-start">
					<Heading size="lg" pt="24px" color={theme.colors.blue[700]}>
						Safety Observation Photos
					</Heading>
				</VStack>
				<Spacer />
				<Button
					color={theme.colors.white}
					bg={theme.colors.blue[700]}
					_hover={{ backgroundColor: theme.colors.blue[800] }}
					onClick={close}
				>
					Close Attachments
				</Button>
			</HStack>
			<Separator />
			<PhotoAttachments
				currentFormId="safety_observation"
				attachmentType="photos"
				attachments={attachmentsList}
				readOnly={readOnly}
				add={add}
				setAdd={setAdd}
				nav={false}
			/>
		</Box>
	);
};
